import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemPromoDiscountMaybe = props => {
  const { lineItems, intl } = props;

  // Find promo discount line items
  const promoDiscountItems = lineItems.filter(item => {
    return item.code && item.code.startsWith('line-item/promo-discount-') && !item.reversal;
  });

  if (promoDiscountItems.length === 0) {
    return null;
  }

  return promoDiscountItems.map((item, index) => {
    const formattedLineTotal = formatMoney(intl, item.lineTotal);
    // Extract promo code from the line item code (e.g., 'line-item/promo-discount-10OFF' -> '10OFF')
    const promoCode = item.code.replace('line-item/promo-discount-', '') || '';
    
    return (
      <div key={index} className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.promoDiscount" values={{ promoCode }} />
        </span>
        <span className={css.itemValue}>{formattedLineTotal}</span>
      </div>
    );
  });
};

LineItemPromoDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemPromoDiscountMaybe; 